// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered {
    display: flex;
    align-items: center;
    justify-content: center;
}

.editing-pane {
    margin: 10px;
}

.c240-editing-pane {
    margin: 0;
}

.close-editing-pane {
    font-size: 25px;
}

.active-slot {

}

.preview-pane {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
}

.default-settings {
    height: 570px;
    width: 100%;
    border: 2px solid black;
    margin-top: 30px;
    margin-bottom: 10px;
}

.select-button {
    margin-top: 10px;
    width: 145px;
    height: 30px;
}

.blur {
    width:100%;
    height:100%;
    background-size:cover;
    pointer-events: none;
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    filter: blur(4px);
}

.relative-position {
    position: relative;
}

.load-slides-message-div {
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 21px;
    text-align:center;
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;
    width: 60%;
    height: 80%;
    display : flex;
    align-items : center;
    background: #fdfefe;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    padding: 5%;
}

.config-reload-message {
    position: absolute;
    left: 30%;
    top: 30%;
    font-size: 21px;
    padding: 3px;
    text-align:center;
    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;
    width: 40%;
    height: 80%;
    display : flex;
    align-items : center;
    background: #fdfefe;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    z-index: 10000;
}

.actionable-buttons-parent-div-set-params {
    display: flex !important;
    justify-content: center; 
    align-items: flex-end;
    padding: 20px;
}

.actionable-buttons-parent-div-set-params-index {
    display: none;
    justify-content: center; 
    align-items: right; 
    padding: 20px;
}

.actionable-buttons-div-set-params {
    display: flex;
    justify-content: center;
    align-items: center;
}

.actionable-buttons-set-params {
    width: 250px;
}

.promt-done-button {
    cursor: pointer;
    border: 1px solid black;
    border-radius: 5px; 
    padding: 10px;
}
.c240-promt-done-button {
    cursor: pointer;
    border: 1px solid black;
    border-radius: 5px; 
    padding: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/set-params.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gDAAgD;IAChD,UAAU;IACV,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gDAAgD;IAChD,UAAU;IACV,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB","sourcesContent":[".centered {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.editing-pane {\n    margin: 10px;\n}\n\n.c240-editing-pane {\n    margin: 0;\n}\n\n.close-editing-pane {\n    font-size: 25px;\n}\n\n.active-slot {\n\n}\n\n.preview-pane {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 20px;\n}\n\n.default-settings {\n    height: 570px;\n    width: 100%;\n    border: 2px solid black;\n    margin-top: 30px;\n    margin-bottom: 10px;\n}\n\n.select-button {\n    margin-top: 10px;\n    width: 145px;\n    height: 30px;\n}\n\n.blur {\n    width:100%;\n    height:100%;\n    background-size:cover;\n    pointer-events: none;\n    -moz-filter: blur(4px);\n    -ms-filter: blur(4px);\n    -o-filter: blur(4px);\n    filter: blur(4px);\n}\n\n.relative-position {\n    position: relative;\n}\n\n.load-slides-message-div {\n    position: absolute !important;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 21px;\n    text-align:center;\n    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;\n    width: 60%;\n    height: 80%;\n    display : flex;\n    align-items : center;\n    background: #fdfefe;\n    border-top: 1px solid #d9d9d9;\n    border-bottom: 1px solid #d9d9d9;\n    padding: 5%;\n}\n\n.config-reload-message {\n    position: absolute;\n    left: 30%;\n    top: 30%;\n    font-size: 21px;\n    padding: 3px;\n    text-align:center;\n    box-shadow: 0 0 7px 0 rgba(0,0,0,0.3) !important;\n    width: 40%;\n    height: 80%;\n    display : flex;\n    align-items : center;\n    background: #fdfefe;\n    border-top: 1px solid #d9d9d9;\n    border-bottom: 1px solid #d9d9d9;\n    z-index: 10000;\n}\n\n.actionable-buttons-parent-div-set-params {\n    display: flex !important;\n    justify-content: center; \n    align-items: flex-end;\n    padding: 20px;\n}\n\n.actionable-buttons-parent-div-set-params-index {\n    display: none;\n    justify-content: center; \n    align-items: right; \n    padding: 20px;\n}\n\n.actionable-buttons-div-set-params {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.actionable-buttons-set-params {\n    width: 250px;\n}\n\n.promt-done-button {\n    cursor: pointer;\n    border: 1px solid black;\n    border-radius: 5px; \n    padding: 10px;\n}\n.c240-promt-done-button {\n    cursor: pointer;\n    border: 1px solid black;\n    border-radius: 5px; \n    padding: 10px;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
